export const ISSUER = (import.meta.env.VITE_SSO_ISSUER as string | undefined)?.replace(/\/$/u, "")
  ?? "https://sso.smartflx.com";
export const PLATFORM_API = (import.meta.env.VITE_PLATFORM_API as string | undefined)?.replace(/\/$/u, "")
  ?? "https://im-platform-api.smartflx.com";
export const PORTAL_CLIENT_ID = "sonox_im_platform_portal";
export const REDIRECT_URI = `${window.location.origin}/callback`;
export const SCOPES = ["openid", "profile", "email", "offline_access"] as const;
export const APP_VERSION = "1.3.0";
